import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { useDispatch, useSelector } from 'react-redux';
import { getUser } from '../../Redux/Slice/User/userSlice';
import { updatePassword, updateProfile } from '../../Services/ProfileServices';

const useMyAccount = () => {

    const dispatch = useDispatch()
    const [isEdit, setIsEdit] = useState("")

    useEffect(() => {
        dispatch(getUser());
    }, [])
    
    const { user } = useSelector((state) => state.user)
    const [isloading, setIsLoading] = useState(false)
    const [firstName, setFirstName] = useState(user?.name)
    const [lastName, setLastName] = useState(user?.last_name)
    const [email, setEmailName] = useState(user?.email)
    const [phone, setPhone] = useState(user?.phone)
    const [oldPassword, setOldPassword] = useState("")
    const [newPassword, setNewPassword] = useState("")
    const [confirmNewPassword, setConfirmNewPassword] = useState("")
    const handleFirstName = (e) => { setFirstName(e.target.value) }
    const handleLastName = (e) => { setLastName(e.target.value) }
    const handlePhone = (e) => { setPhone(e.target.value) }
    const handleOldpass = (e) => { setOldPassword(e.target.value) }
    const handleNewpass = (e) => { setNewPassword(e.target.value) }
    const handleConfirmNewpass = (e) => { setConfirmNewPassword(e.target.value) }

    const handleSubmit = async (e) => {
        e.preventDefault()
        setIsLoading(true)
        let response = await updateProfile({ first_name: firstName, last_name: lastName, phone })
        if (response.statusCode === 200) {
            toast?.success(response?.message)
            setIsLoading(false)
            setIsEdit("")
            dispatch(getUser())
        } else if (response.statusCode === 401) {
            toast?.error(response?.errors)
            setIsLoading(false)
        } else {
            for (const [key, value] of Object.entries(response?.errors)) {
                toast?.error(value)
            }
            setIsLoading(false)
        }
        setIsLoading(false)
    }

    const handleChangePass = async (e) => {
        e.preventDefault()
        setIsLoading(true)
        let response = await updatePassword({ old_password: oldPassword, password: newPassword, password_confirmation: confirmNewPassword })
        if (response.statusCode === 200) {
            toast?.success(response?.message)
            setIsLoading(false)
            setIsEdit("")
            setOldPassword("")
            setNewPassword("")
            setConfirmNewPassword("")
        } else if (response.statusCode === 401) {
            toast?.error(response?.message)
            setIsLoading(false)
        } else {
            for (const [key, value] of Object.entries(response?.errors)) {
                toast?.error(value)
            }
            setIsLoading(false)
        }
        setIsLoading(false)
    }

    return [
        isEdit,
        setIsEdit,
        email,
        isloading,
        firstName,
        lastName,
        phone,
        oldPassword,
        newPassword,
        confirmNewPassword,
        handleFirstName,
        handleLastName,
        handlePhone,
        handleOldpass,
        handleNewpass,
        handleConfirmNewpass,
        handleSubmit,
        handleChangePass
    ]
}

export default useMyAccount